import { Card, Typography, Button, Stack, TableContainer, TableHead, TableRow, TableCell, Table, Avatar, TableBody, IconButton, MenuItem, Popover, Dialog, DialogTitle, DialogContent, TextField, Paper, Box, FormControl, Select, Autocomplete, Switch, Grid, Tooltip, InputBase, Chip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import '../../Common_css/style.css';
import Iconify from 'src/components/iconify';
import { deleteData, formPostData, getData, patchFormData } from "src/webService/webService";
import { toast, ToastContainer } from "react-toastify";
import uploadIcon from '../../components/images/upload-placeholder.webp';
import deleteIcon from '../../components/icons/remove.png';
import Loader from "../Loader/Loader";


export default function Brands() {

    const Token = sessionStorage.getItem('Token');
    const [brandList, setBrandList] = useState([]);
    const [action, setAction] = useState('');
    const [open, setOpen] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [thumbnail, setThumbnail] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        category: []
    });
    const [errors, setErrors] = useState({});
    const initialImage = uploadIcon;
    const [preview, setPreview] = useState(initialImage);
    const [imageFiles, setImageFiles] = useState([]);
    const [resId, setResId] = useState('');
    const role = sessionStorage.getItem('Role');
    const [getBrandId, setGetBrandId] = useState('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [resImages, setResImages] = useState([]);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const [loader, setLoader] = useState(false);
    const [profileCategories, setProfileCategories] = useState([]);
    const [categoriesArray, setCategoriesArray] = useState([]);
    const [activeStates, setActiveStates] = useState({});
    const [previewVideo, setPreviewVideo] = useState(null);
    const [profileIntroVideo, setProfileIntroVideo] = useState('');
    const [brandPendingStatus, setBrandPendingStatus] = useState(false);
    const [availableBrands, setAvailableBrands] = useState(null)
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    const debounce = (func, delay) => {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const debouncedSearch = debounce((query) => {
        if (query.length >= 3 || query.length === 0) {
            setSearchQuery(query);
            getBrands(1, query);
        }
    }, 500);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleCategoryChange = (event, newValue) => {
        const selectedIds = newValue.map((item) => item._id);
        setProfileCategories(selectedIds);
    };

    const getCategoryData = async () => {
        const params = {
            // page: 1,
            // per_page: 20,
            all: 1,
            withChildren: 1
        }
        try {
            const res = await getData('categories', params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setCategoriesArray(res.data);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const handleSubmit = (e) => {
        debugger
        e.preventDefault();

        const formDataToSend = new FormData();

        formDataToSend.append("name", formData.name);
        formDataToSend.append("description", formData.description);
        formDataToSend.append("category", JSON.stringify(profileCategories));

        // if (profileCategories.length > 0) {
        //     formDataToSend.append("categories", profileCategories.join(','));
        // }

        if (thumbnail) {
            formDataToSend.append("thumbnail", thumbnail);
        }

        if (profileIntroVideo) {
            formDataToSend.append("intro_video", profileIntroVideo);
        }

        imageFiles.forEach((file) => {
            formDataToSend.append("images[]", file);
        });

        const isUpdate = !!formData._id;

        let url = isUpdate
            ? `seller/brand/${formData._id}`
            : `seller/brand`;

        if (isUpdate) {
            formDataToSend.append("_method", "PUT");
        }

        formPostData(url, formDataToSend, Token)
            .then((res) => {
                getBrands(currentPage);
                toast.success(isUpdate ? 'Brand updated successfully' : 'Brand added successfully');
                handleClose();
                setImageFiles([]);
                setPreview(uploadIcon);
                setPreviewVideo(null);
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error("Error submitting brand");
            });
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        setLimit(event.target.value);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setThumbnail(file);
        }
    };

    const handleOpenMenu = (event, id) => {
        setOpen(event.currentTarget);
        getBrandsById(id);
    };

    const handleCloseMenu = () => {
        setOpen(null);
    }

    const handleOpenModal = () => {
        debugger
        getCategoryData();
        setOpenModal(true);
    }

    const handleClose = () => {
        setOpenModal(false);
        setFormData('');
        setPreview(uploadIcon);
        setOpen(null);
    }

    const getBrands = async (page, search = "") => {
        setLoader(true)
        const params = {
            page: page,
            per_page: limit,
            search: search
        }
        try {
            if (role === 'Seller') {
                const res = await getData('seller/brand', params, Token);
                if (res.status === 200) {
                    console.log(res.data, "res.data");
                    setBrandList(res.data);
                    setTotalItems(res?.total);
                    setTotalPages(res?.last_page);
                    setBrandPendingStatus(res.pending_brand_setup);
                    setAvailableBrands(res.available_brands)
                }
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        getBrands(currentPage);
    }, [limit, currentPage])

    const getBrandsById = async (id) => {
        debugger
        try {
            if (role === 'Admin') {
                const res = await getData(`sellers/brand/${id}`, null, Token);
                if (res.status === 200) {
                    console.log(res.data, "res.data");
                    // setBrandList(res.data)
                }
            } else if (role === 'Seller') {
                const res = await getData(`seller/brand/${id}`, null, Token);
                if (res.status === 200) {
                    // console.log(res.data, "res.data");
                    // setBrandList(res.data)
                    setPreview(res?.thumbnail);
                    setProfileCategories(res?.category)
                    setFormData({
                        name: res?.name,
                        description: res?.description
                    });
                    setResImages(res?.galleryFiles)
                    if (res?.intro_video) {
                        setPreviewVideo(res?.intro_video);
                    }
                }
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const handleSwitchChange = (checked, id) => {
        debugger;
        const brand = brandList.find(item => item._id === id);
        const brandName = brand?.name || '';
        setActiveStates(prev => ({
            ...prev,
            [id]: !checked,
        }));
        const formData = new FormData();
        formData.append('isActive', checked === false ? 0 : 1);
        formData.append('name', brandName);

        patchFormData(`seller/brand/${id}`, formData, Token)
            .then((res) => {
                getBrands(currentPage);
                getCategoryData();
                handleClose();
                handleCloseMenu();
                toast.success('Brand updated successfully');
            })
            .catch((error) => {
                console.error("Error:", error);
                setActiveStates(prev => ({
                    ...prev,
                    [id]: !checked,
                }));
                toast.error('Failed to update brand status');
            });
    };

    const handleOpenDeleteModal = () => {
        setOpenDeleteModal(true);
    }

    const handleDeleteClose = () => {
        setOpenDeleteModal(false);
        handleCloseMenu();
    }

    const deleteBrand = async () => {
        try {
            const res = await deleteData(`seller/brand/${getBrandId}`, Token);
            getBrands(currentPage);
            handleDeleteClose();
            handleCloseMenu();
            // toast.success('category deleted successfully')
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const handleVideoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const videoURL = URL.createObjectURL(file);
            setPreviewVideo(videoURL);
            setProfileIntroVideo(file);
        }
    };

    return (
        <>
            <ToastContainer position="top-right" />
            <Helmet>
                <title>Brands</title>
            </Helmet>

            <div className='p-0 GoToBrands'>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Stack direction="row" alignItems="center" gap={65}>
                        <Typography variant="h4" className='title-color' gutterBottom>
                            Brands
                            <Chip
                                sx={{ marginLeft: "10px", fontSize: "8px", fontWeight: "bold", height: "20px", border: "1px solid #010101" }}
                                label={`Available Brands : ${availableBrands} `}
                                component='a'
                                variant='outlined'
                            />
                        </Typography>
                        {/* <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "none",
                                borderRadius: "15px",
                                boxShadow: 1,
                                border: "1px solid #010101"
                            }}
                        >
                            <Iconify icon="eva:search-fill" sx={{ marginLeft: "10px" }} />
                            <InputBase
                                placeholder="Search"
                                value={searchText}
                                onChange={(e) => {
                                    setSearchText(e.target.value);
                                    debouncedSearch(e.target.value);
                                }}
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box> */}
                    </Stack>
                    <Tooltip title={!brandPendingStatus ? 'Contact Admin to Add Additional Brand' : ''}>
                        <span>
                            <Button variant="contained" disabled={!brandPendingStatus} className='Button' onClick={(event) => { handleOpenModal('Add'); setAction('Add') }} startIcon={<Iconify icon="eva:plus-fill" />}>
                                New Brand
                            </Button>
                        </span>
                    </Tooltip>
                </Stack>
                {loader ? (
                    <Loader />
                ) : (
                    <Card className='card-bg'>
                        <TableContainer style={{ height: "420px", overflowY: "scroll", width: "100%" }}>
                            <Table stickyHeader style={{ width: "100%" }}>
                                <TableHead>
                                    <TableRow>
                                        {/* <TableCell className="table-cl color-dark" width='20%'>
                                            Brand Thumbnail
                                        </TableCell> */}
                                        <TableCell className="table-cl color-dark mx-10" width='30%'>
                                            Brand Name
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-20">
                                            Brand Category
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-15">
                                            Status
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-10">
                                            Action
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {brandList?.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell className="table-cl color-dark mx-5" align="center">
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                    gap={1}
                                                >
                                                    {item?.thumbnail ? (
                                                        <Avatar src={item?.thumbnail}></Avatar>
                                                    ) : (
                                                        <Avatar>
                                                            {item.name
                                                                ? item.name[0]
                                                                : null}
                                                        </Avatar>
                                                    )}
                                                    {item?.name}
                                                </Stack>
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-10">
                                                {item?.category_names}
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-10">
                                                <Switch
                                                    checked={item?.isActive === false ? !activeStates : activeStates}
                                                    onChange={(e) => handleSwitchChange(e.target.checked, item._id)}
                                                />
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-10">
                                                <IconButton
                                                    size="large"
                                                    color="inherit"
                                                    onClick={(event) => {
                                                        handleOpenMenu(event, item?._id);
                                                        setGetBrandId(item?._id)
                                                    }}
                                                >
                                                    <Iconify icon={"eva:more-vertical-fill"} />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="d-flex flex-wrap justify-content-end m-3">
                            <FormControl variant="outlined" size="small" style={{ width: "6%" }}>
                                <Select
                                    labelId="limit-label"
                                    id="limit-select"
                                    value={limit}
                                    onChange={handleLimitChange}
                                >
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                    <MenuItem value={30}>30</MenuItem>
                                    <MenuItem value={TotalItems}>All</MenuItem>
                                </Select>
                            </FormControl>
                            <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                                <Iconify icon={"grommet-icons:previous"} />
                            </Button>
                            <Button
                                onClick={handleNextPage}
                                disabled={currentPage === totalPages}
                            >
                                <Iconify icon={"grommet-icons:next"} />
                            </Button>
                        </div>
                        <Popover
                            open={Boolean(open)}
                            anchorEl={open}
                            onClose={handleCloseMenu}
                            anchorOrigin={{ vertical: "top", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            PaperProps={{
                                sx: {
                                    p: 1,
                                    width: 200,
                                    "& .MuiMenuItem-root": {
                                        px: 1,
                                        typography: "body2",
                                        borderRadius: 0.75,
                                    },
                                },
                            }}
                        >
                            <MenuItem
                                onClick={() => {
                                    setAction("Edit");
                                    handleOpenModal();
                                    setFormData(prev => ({ ...prev, _id: getBrandId }));
                                }}
                            >
                                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
                                Edit
                            </MenuItem>
                            {/* <MenuItem
                                sx={{ color: "error.main" }}
                                onClick={() => {
                                    handleOpenDeleteModal();
                                }}
                            >
                                <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
                                Delete
                            </MenuItem> */}
                        </Popover>
                    </Card>

                )}
            </div>
            <Dialog open={openModal} onClose={handleClose} maxWidth="md" fullWidth>
                <div className="d-flex justify-content-between">
                    <DialogTitle>{action} Brand</DialogTitle>
                    <Iconify icon='material-symbols:close-rounded' sx={{ margin: '12px', cursor: 'pointer' }} onClick={handleClose} />
                </div>
                <DialogContent>
                    <Paper elevation={3} sx={{ padding: 2, marginTop: 0, borderRadius: 2 }}>
                        <form>
                            <Box display="flex" flexDirection="column" gap={2} sx={{ marginTop: 1 }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                id="fileInput"
                                                style={{ display: "none" }}
                                                onChange={handleImageChange}
                                            />
                                            <label htmlFor="fileInput">
                                                <img
                                                    src={preview}
                                                    alt="Uploaded"
                                                    style={{
                                                        width: "300px",
                                                        height: "230px",
                                                        objectFit: "contain",
                                                        cursor: "pointer",
                                                        borderRadius: "10px",
                                                    }}
                                                />
                                                <p className='mb-0' style={{ fontSize: '12px' }}>Upload Thumbnail image</p>
                                            </label>
                                            {errors.thumbnail && (
                                                <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                    {errors.thumbnail}
                                                </p>
                                            )}
                                        </div>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <div className="BrandVideo" style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                                            <input
                                                type="file"
                                                accept="video/*"
                                                id="videoInput"
                                                style={{ display: "none" }}
                                                onChange={handleVideoChange}
                                            />
                                            <label htmlFor="videoInput">
                                                {previewVideo ? (
                                                    <video
                                                        src={previewVideo}
                                                        controls
                                                        style={{
                                                            width: "300px",
                                                            height: "220px",
                                                            objectFit: "contain",
                                                            cursor: "pointer",
                                                            borderRadius: "10px",
                                                        }}
                                                    />
                                                ) : (
                                                    <div style={{
                                                        width: "300px",
                                                        height: "230px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        backgroundColor: "#f0f0f0",
                                                        borderRadius: "10px",
                                                        cursor: "pointer"
                                                    }}>
                                                        <p style={{ fontSize: '14px', color: '#666' }}>Click to upload video</p>
                                                    </div>
                                                )}
                                                <p className='mb-0' style={{ fontSize: '12px' }}>Upload video</p>
                                            </label>
                                        </div>
                                    </Grid>
                                </Grid>
                                <TextField
                                    label="Brand Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                    error={!!errors.name}
                                    helperText={errors.name}
                                    disabled={action === "Edit"}
                                />
                                <TextField
                                    label="Description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                    error={!!errors.description}
                                    helperText={errors.description}
                                />
                                <Autocomplete
                                    multiple
                                    required
                                    options={(categoriesArray || []).filter((cat) => cat.subCategoryCount === 0)}
                                    groupBy={(option) => {
                                        const parent = categoriesArray.find(
                                            (parentCat) => parentCat._id == option.parent
                                        );
                                        return parent?.name || 'Uncategoriezed';
                                    }}
                                    getOptionLabel={(option) => ((option.parent != null) ? "" : "") + `${option.name}`}
                                    value={categoriesArray.filter((item) => profileCategories.includes(item._id))}
                                    onChange={handleCategoryChange}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Category" variant="outlined" />
                                    )}
                                    renderGroup={(params) => (
                                        <div key={params.key}>
                                            <Typography sx={{ mt: 0, mb: 0, fontWeight: 'bold', px: 2, background: '#dbdee2' }}>
                                                {params.group}
                                            </Typography>
                                            {params.children}
                                        </div>
                                    )}
                                />
                                <div className='mt-4 d-flex justify-content-end'>
                                    <Button variant="contained" type="submit" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </div>
                            </Box>
                        </form>
                    </Paper>
                </DialogContent>
            </Dialog>
            <Dialog open={openDeleteModal} onClose={handleDeleteClose} maxWidth="sm" fullWidth>
                <DialogContent className='p-5'>
                    <div>
                        <div className='d-flex justify-content-center'>
                            <img src={deleteIcon} width='10%' />
                        </div>
                        <h4 className='text-center mt-4'>Confirm deletion?</h4>
                        <p className='text-center'>Data will be lost forever.</p>
                        <Button variant="contained" className='Button w-100 mt-3 shadow-none' onClick={(e) => deleteBrand()}>
                            Yes
                        </Button>
                        <Button variant="outlined" className='w-100 mt-3' onClick={(e) => handleDeleteClose()} >
                            No
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}